import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
   <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, A B Ghule Enterprises, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | A B Ghule Enterprises | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="A B Ghule Enterprises" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "A B Ghule Enterprises - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with A B Ghule Enterprises. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend A B Ghule Enterprises for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, A B Ghule Enterprises, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>Terms & Conditions</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            {/* Text Content Column */}
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> Bookings with A B Ghule Enterprises are subject to availability and will be confirmed upon receipt of full payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Payments must be completed at the time of booking via our secure online portal or authorized payment methods.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Changes or cancellations to bookings must comply with our cancellation policy, which may include applicable fees based on the timing of the request.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers are required to carry valid identification and booking confirmations. A B Ghule Enterprises reserves the right to deny service without proper documentation.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Passengers may bring a limited amount of baggage per booking. Excess baggage may incur additional charges.</p>

                <p><b className="highlight">6. Travel Insurance:</b> While we ensure a safe journey, we recommend obtaining travel insurance for unforeseen circumstances.</p>

                <p><b className="highlight">7. Safety Regulations:</b> All passengers must adhere to safety guidelines and driver instructions to ensure a secure journey.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> A B Ghule Enterprises reserves the right to adjust routes or schedules due to weather, traffic, or other unforeseen conditions.</p>

                <p><b className="highlight">9. Refusal of Service:</b> We may refuse service to passengers exhibiting inappropriate behavior, violating terms, or compromising safety.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by Indian laws, and any disputes will be settled in Pune jurisdiction.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Book your cab via our website or customer service helpline for a seamless experience.</p>
                <p><b className="highlight">Customer Support:</b> Our dedicated team is available 24/7 to address your questions and concerns.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Fees:</b> Refunds may be subject to cancellation charges based on the timing of the request.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be processed within 7-10 business days through the original payment method.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows are not eligible for refunds or rescheduling.</p>
              </div>
            </div>

            {/* Image Column */}
            <div className="col-md-5">
              <div className="image-container">
                <img src="/images/term-condition.jpg" alt="Terms and Conditions" className="terms-image" />
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or need clarification about our terms, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918624029699">+91 8624029699</a></li>
              <li><b>Email:</b> <a href="mailto:booking@abghulecabs.com">booking@abghulecabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
